import { Grid } from '@mui/material';
import { AppCard } from 'views/dashboard/AppCard';
import MainCard from 'ui-component/cards/MainCard';
import _ from 'lodash';
import KnockNotificationWidget from 'ui-component/third-party/KnockNotificationWidget';
import { useAppAccessContext } from 'contexts/AppAccessContext';
import { gridSpacing } from 'constants/themeConstants';
import { IS_KNOCK_PROD } from 'constants/envConstants';

const Dashboard = () => {
  const { isLoading: isLoadingAppAccess, appsWithPermissions } =
    useAppAccessContext();

  const enabledApps = _.values(appsWithPermissions).filter(
    (app) =>
      app.permissions?.state === 'enabled' &&
      !app.permissions?.comingSoon &&
      app.path
  );
  const disabledApps = _.values(appsWithPermissions).filter(
    (app) =>
      app.permissions?.state !== 'enabled' && !app.permissions?.comingSoon
  );
  const comingSoonApps = _.values(appsWithPermissions).filter(
    (app) => app.permissions?.comingSoon
  );

  return (
    <Grid
      container
      spacing={gridSpacing}
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid
        container
        item
        xs={6}
        spacing={gridSpacing}
        direction="column"
        justifyContent="flex-start"
      >
        <Grid item xs={12}>
          <MainCard title="Your Apps">
            <Grid container spacing={gridSpacing}>
              {enabledApps.map((app) => (
                <AppCard
                  key={app.id}
                  app={app}
                  isLoading={isLoadingAppAccess}
                />
              ))}
            </Grid>
          </MainCard>
        </Grid>
        {!!disabledApps.length && (
          <Grid item xs={12}>
            <MainCard title="Disabled Apps">
              <Grid container spacing={gridSpacing}>
                {disabledApps.map((app) => (
                  <AppCard
                    key={app.id}
                    app={app}
                    isLoading={isLoadingAppAccess}
                  />
                ))}
              </Grid>
            </MainCard>
          </Grid>
        )}
        {!!comingSoonApps.length && (
          <Grid item xs={12}>
            <MainCard title="Coming Soon">
              <Grid container spacing={gridSpacing}>
                {comingSoonApps.map((app) => (
                  <AppCard
                    key={app.id}
                    app={app}
                    isLoading={isLoadingAppAccess}
                  />
                ))}
              </Grid>
            </MainCard>
          </Grid>
        )}
      </Grid>
      <Grid item xs={6}>
        <MainCard>
          <KnockNotificationWidget
            authWithKnock={IS_KNOCK_PROD}
            variant="inbox"
          />
        </MainCard>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
